module.exports = __webpack_public_path__ + "static/media/yarn2.ca8bda05.jpg";